<template>
  <div class="row q-pa-md items-center">
    <div style="display: inline-block" class="text-h6">
      <q-btn @click="$emit('close')" flat>
        <q-icon name="mdi-arrow-left"> </q-icon>
      </q-btn>
      Placings
    </div>
    <div v-if="events.length > 1" class="col-12">
      <q-tabs v-model="chosenEvent">
        <q-tab
          :name="index"
          :label="event.label"
          v-for="(event, index) in events"
          :key="`event_${index}`"
        ></q-tab>
      </q-tabs>
    </div>
    <div class="col-12">
      <div
        class="row"
        v-if="
          currentEventRounds &&
            currentEventRounds.rounds &&
            currentEventRounds.rounds.length > 0
        "
      >
        <div class="col-12">
          <q-scroll-area
            :style="
              `height: calc(100vh - ${
                events.length > 1 ? '457px' : '410px'
              }) !important`
            "
          >
            <div class="row">
              <div
                class="col-12 mt-0 pt-0"
                :style="
                  `height: calc(100vh - ${
                    events.length > 1 ? '480px' : '425px'
                  }) !important`
                "
              >
                <datatable
                  :filter="search"
                  :flat="true"
                  :data="placingsData"
                  :columns="columns"
                  @rowDoubleClick="handleDoubleClick"
                  :hidePagination="true"
                >
                  <template slot="body-cell-qualified" slot-scope="data">
                    <q-td :props="data.props">
                      <q-icon
                        size="sm"
                        :name="
                          totalQual
                            ? `${
                                data.props.rowIndex < totalQual
                                  ? 'mdi-check'
                                  : 'mdi-close'
                              }`
                            : currentEventRounds.rounds[0].races.length *
                                qualPerRace >
                              registeredParticipants.length
                            ? `${
                                data.props.rowIndex <
                                registeredParticipants.length
                                  ? 'mdi-check'
                                  : 'mdi-close'
                              }`
                            : `${
                                data.props.rowIndex <
                                currentEventRounds.rounds[0].races.length *
                                  qualPerRace
                                  ? 'mdi-check'
                                  : 'mdi-close'
                              }`
                        "
                        :color="
                          totalQual
                            ? `${
                                data.props.rowIndex < totalQual
                                  ? 'positive'
                                  : 'negative'
                              }`
                            : currentEventRounds.rounds[0].races.length *
                                qualPerRace >
                              registeredParticipants.length
                            ? `${
                                data.props.rowIndex <
                                registeredParticipants.length
                                  ? 'positive'
                                  : 'negative'
                              }`
                            : `${
                                data.props.rowIndex <
                                currentEventRounds.rounds[0].races.length *
                                  qualPerRace
                                  ? 'positive'
                                  : 'negative'
                              }`
                        "
                      ></q-icon>
                    </q-td>
                  </template>
                </datatable>
              </div>
            </div>
          </q-scroll-area>
        </div>
        <div class="col-12 text-right">
          <q-btn
            label="Finish & Publish"
            color="primary"
            no-caps
            style="z-index: 2"
            :loading="submitPlacingsLoading"
            @click="submitPlacings"
          ></q-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import datatable from "@/components/datatable/datatable.vue";

// import { Notify } from "quasar";

export default {
  components: { datatable },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      siteCFG: "settings/siteCFG",
      registeredParticipants: "events/registeredParticipants",
      event: "events/current",
      currentEventRounds: "eventProgress/currentEventRounds",
      currentEventRoundsLoading: "eventProgress/currentEventRoundsLoading",
      competition: "competitions/current"
    })
  },
  data: () => ({
    columns: [
      {
        name: "rank",
        label: "Rank",
        align: "left",
        field: "rank",
        style:
          "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "name",
        label: "Name",
        align: "left",
        field: "name",
        style:
          "min-width: 180px;max-width: 180px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "association_abbr",
        label: "Club",
        align: "left",
        field: "association_abbr",
        style:
          "min-width: 180px;max-width: 180px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "points",
        label: "Points",
        align: "left",
        field: "points",
        style:
          "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "wins",
        label: "Wins",
        align: "left",
        field: "wins",
        style:
          "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis",
        sortable: true
      },
      {
        name: "worstPos",
        label: "Worst PL",
        align: "left",
        field: "worstPos",
        style:
          "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      }
    ],
    search: "",
    placingsData: [],
    lanesDrawing: false,

    events: [],
    chosenEvent: 0,

    submitPlacingsLoading: false
  }),
  watch: {
    currentEventRounds: function() {
      this.generatePlacingsData();
    },
    chosenEvent: function() {
      this.generatePlacingsData();
    }
  },
  mounted() {
    this.$store.dispatch("events/loadRegisteredParticipants", this.event.id);
    this.$store
      .dispatch("eventProgress/loadCurrentEventRoundsObject", this.event.id)
      .then(() => {
        this.generatePlacingsData();
      });
  },
  methods: {
    handleDoubleClick() {},
    generatePlacingsData(specificEvent = null) {
      if (this.currentEventRounds && this.currentEventRounds.rounds) {
        if (!specificEvent) {
          this.events = [];
          this.currentEventRounds.rounds.forEach(round => {
            round.races.forEach(race => {
              if (race.ce_eventFinal) {
                this.events.push({ id: race.ce_events_id, label: race.label });
              }
            });
          });
        }

        let members = [];
        let memberLinks = {};
        let isTeamEvent =
          JSON.parse(this.currentEventRounds.playerLabels).length > 1;

        JSON.parse(JSON.stringify(this.currentEventRounds)).rounds.forEach(
          round => {
            round.races.forEach(race => {
              if (
                this.events.length < 2 ||
                (race.ce_events_id == this.events[this.chosenEvent].id &&
                  !specificEvent) ||
                race.ce_events_id == specificEvent
              ) {
                race.lanes.forEach(lane => {
                  let memberIndex = 0;
                  // Cannot be !memberLinks[lane.participant_id] as index 0 will pass this check doubling the amount of entries
                  if (typeof memberLinks[lane.participant_id] == "undefined") {
                    memberLinks[lane.participant_id] = members.length;
                    memberIndex = members.length;
                    members.push({
                      rank: null,
                      id: lane.participant_id,
                      events_id: lane.events_id,
                      name: isTeamEvent
                        ? lane.team_name
                        : `${lane.firstName} ${lane.lastName}`,
                      association_abbr: lane.association_abbr,
                      association_id: lane.associations_id,
                      points: 0,
                      wins: 0,
                      worstPos: 0,
                      isTeamEvent: isTeamEvent ? 1 : 0
                    });
                  } else {
                    memberIndex = memberLinks[lane.participant_id];
                  }
                  members[memberIndex].points += lane.points
                    ? parseInt(lane.points)
                    : 0;
                  members[memberIndex].wins +=
                    parseInt(lane.placing) == 1 ? 1 : 0;
                  members[memberIndex].worstPos =
                    parseInt(lane.placing) > members[memberIndex].worstPos
                      ? parseInt(lane.placing)
                      : members[memberIndex].worstPos;
                });
              }
            });
          }
        );

        members.sort((a, b) => {
          let p1 = a.points;
          let p2 = b.points;

          let w1 = a.wins;
          let w2 = b.wins;

          let wp1 = a.worstPos;
          let wp2 = b.worstPos;

          if (p1 < p2) return 1;
          if (p1 > p2) return -1;
          if (w1 < w2) return 1;
          if (w2 > w1) return -1;
          if (wp1 < wp2) return -1;
          if (wp2 > wp1) return 1;
          return 0;
        });

        let currentRank = 1;
        members.forEach((member, index) => {
          if (index == 0) {
            currentRank = 1;
            member.rank = 1;
          } else {
            let prevMember = members[index - 1];
            if (
              prevMember.points == member.points &&
              prevMember.wins == member.wins &&
              prevMember.worstPos == member.worstPos
            ) {
              members[index - 1].rank = Number.isInteger(prevMember.rank)
                ? `${prevMember.rank}=`
                : `${prevMember.rank}`;
              member.rank = `${prevMember.rank}`;
              currentRank += 1;
            } else {
              currentRank += 1;
              member.rank =
                this.currentEventRounds.rounds.length == 1
                  ? currentRank
                  : index + 1;
            }
          }
        });

        if (!specificEvent) {
          this.placingsData = members;
        }
        return members;
      }
    },

    async submitPlacings() {
      // this.submitPlacingsLoading = true;
      // let requests = [];
      // if (this.events.length > 1) {
      //   this.events.forEach((event) => {
      //     requests.push(
      //       this.submitPlacingsAsync({
      //         placings: this.generatePlacingsData(event.id),
      //       })
      //     );
      //   });
      // } else {
      //   let requests = [];
      //   requests.push(
      //     this.submitPlacingsAsync({
      //       placings: this.placingsData,
      //     })
      //   );
      // }

      // let response = await Promise.all(requests);
      // this.submitPlacingsLoading = false;

      // this.$emit("close");
      // this.$router.push(`${this.$route.path.split("/events")[0]}/events`);
      // this.$q.notify({
      //   position: "top-right",
      //   type: "positive",
      //   message: "The event has been finished",
      // });
      this.$store.dispatch(
        "eventProgress/submitPlacings",
        this.currentEventRounds.id
      );
    },
    async submitPlacingsAsync(payload) {
      try {
        let response = await this.$store.dispatch(
          "eventProgress/submitPlacings",
          payload
        );
        return response;
      } catch (error) {
        return error;
      }
    }
  }
};
</script>
